import * as React from "react";
import { cn } from "./utils";

function Input({
  className,
  type,
  autoComplete = "off",
  ...props
}: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input flex h-9 w-full min-w-0 rounded-lg border px-3 py-1 text-sm bg-input-background text-foreground backdrop-blur-xs transition-all duration-150 outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:border-primary/80 focus-visible:ring-ring focus-visible:ring-[2px] hover:border-border",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      autoComplete={autoComplete}
      {...props}
    />
  );
}

export { Input };
